var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"d-flex flex-column px-0 px-md-1 px-lg-1"},[_c('img',{staticClass:"DhlLabel",attrs:{"src":require('@/assets/images/image4.png'),"alt":"DHL LABEL"}})])}
var staticRenderFns = []

export { render, staticRenderFns }